
export const putProgramaticDescription = async ({ platformClient, objectType, objectId, key, value }) => {
  const response = await platformClient.put(`${process.env.VUE_APP_AMUNDSEN_META_URL}/${objectType}/${objectId}/programmatic_descriptions`, { [key]: value });
  return response.data;
};
